import { render, staticRenderFns } from "./addFinanceItem.vue?vue&type=template&id=61080413&scoped=true"
import script from "./addFinanceItem.vue?vue&type=script&lang=js"
export * from "./addFinanceItem.vue?vue&type=script&lang=js"
import style0 from "./addFinanceItem.vue?vue&type=style&index=0&id=61080413&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61080413",
  null
  
)

export default component.exports